module.exports = __webpack_public_path__ + "img/logo_przedruk.6174fde0.png";